module.exports = __webpack_public_path__ + "media/images/icons/vertical-align-bottom-8d670fde3f1649d4869352b47ffc7713.svg";